import { render, staticRenderFns } from "./collagePopup.vue?vue&type=template&id=667812ca&scoped=true"
import script from "./collagePopup.vue?vue&type=script&lang=ts"
export * from "./collagePopup.vue?vue&type=script&lang=ts"
import style0 from "./collagePopup.vue?vue&type=style&index=0&id=667812ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667812ca",
  null
  
)

export default component.exports